// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCgxCManHz6n4RFO4RZS6H0M7PdAC_gzn4",
  authDomain: "kuni3d-7b16e.firebaseapp.com",
  projectId: "kuni3d-7b16e",
  storageBucket: "kuni3d-7b16e.firebasestorage.app",
  messagingSenderId: "459966768221",
  appId: "1:459966768221:web:20b458f8367efe273d19b4",
  measurementId: "G-FKSMG9BXNW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
